import { useEffect, useState } from "react";
import useSessions, { SessionProps } from "./useSessions";

import useTime from "./useTime";

const useLiveSession = (roomID?: number) => {
  const now = useTime();
  const sessions = useSessions();
  const [session, setSession] = useState<SessionProps | undefined>();

  useEffect(() => {
    if (sessions && roomID) {
      const session = sessions.find((session: SessionProps) => {
        return (
          session.timeStart <= now &&
          session.timeEnd > now &&
          session.room === roomID
        );
      });

      if (session) {
        setSession(session);
      }
    }
  }, [now, roomID, sessions]);

  return session;
};

export default useLiveSession;
